import React, {useContext, useEffect, useState} from "react";
import {Badge, LoginWrapper, WelcomeMessage} from "./styles";
import {useTranslation} from "react-i18next";
import clock from '../../../../assets/images/reservation/clock.svg';
import LoginDialog from "./LoginDialog";
import {useDispatch, useSelector} from "react-redux";
import {selectBoaterMail, selectForceLogin} from "../../../../store/slices/reservation/selectors";
import {reservationActions} from "../../../../store/slices/reservation/reservationSlice";
import {AuthContext} from "../../../../context/AuthProvider";

const Login = () => {
    // TODO: integrate with boater auth logic
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const { loggedIn } = useContext(AuthContext);
    const email = useSelector(selectBoaterMail);
    const { user: boater } = useContext(AuthContext);
    const forceLogin = useSelector(selectForceLogin);

    useEffect(() => {
        setOpen(false);
    }, [loggedIn]);

    if(loggedIn) {
        return (<LoginWrapper>
            <Badge>
                {boater?.first_name.charAt(0).toUpperCase()}{boater?.last_name.charAt(0).toUpperCase()}
            </Badge>
            <WelcomeMessage className="welcome-boater">
                {t('WELCOME_MESSAGE', {name: `${boater?.first_name} ${boater?.last_name}`})}
            </WelcomeMessage>
        </LoginWrapper>)
    }

    return (<LoginWrapper>
        {t('HAVE_AN_ACCOUNT')}&nbsp;
        <span className="login-to-pickapier" onClick={() => setOpen(true)}>{t('LOGIN_TO_PICKAPIER')}</span>&nbsp;
        {t('TO_SPEED_THINGS_UP')}
        <img src={clock} alt="clock"/>
        <LoginDialog force={forceLogin} email={email} open={open} onClose={() => {
            setOpen(false);
            dispatch(reservationActions.setForceLogin(false));
        }}/>
    </LoginWrapper>)
}

export default Login;
